import { Component, ElementRef, ViewChild, OnInit, ChangeDetectorRef, Renderer2, OnDestroy, HostListener } from '@angular/core';
import { LayoutService } from './service/app.layout.service'; import { Subscription } from 'rxjs';
import { PedidosService } from 'src/app/services/pedidos.service';
import { Router } from '@angular/router'; import { ColorScheme } from 'src/app/layout/service/app.layout.service';
import { AvatarService } from 'src/app/services/avatar.service';
import { UsetifulService } from 'src/app/services/usetiful.service';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html',
    styleUrls: ['./app.sidebar.component.scss']
})
export class AppSidebarComponent implements OnInit, OnDestroy {
    timeout: any = null;
    logoSrc: string = 'assets/Logo_claro_sem.svg'; // Default logo

    @ViewChild('menuContainer') menuContainer!: ElementRef;
    @HostListener('window:click', ['$event'])
    @HostListener('window:touchstart', ['$event'])
    onDocumentClick(event: Event): void {
        const clickedInside = this.el.nativeElement.contains(event.target);
        const isMobile = window.innerWidth <= 768;
        // console.log('--- Clique detectado ---');
        // console.log('Target:', event.target);
        // console.log('clickedInside:', clickedInside);
        // console.log('ignoreNextClick:', this.layoutService.ignoreNextClick);
        // console.log('isMobile:', isMobile);
        if (this.layoutService.ignoreNextClick) {
            this.layoutService.ignoreNextClick = false; // reseta
            return;
        }

        if (!clickedInside && isMobile) {
            this.closeSidebar();
        }
    }

    closeSidebar() {
        // Fecha o modo overlay (desktop ou mobile)
        this.layoutService.state.overlayMenuActive = false;

        // Fecha o menu mobile
        this.layoutService.state.staticMenuMobileActive = false;

        // Se quiser forçar re-render para garantir:
        this.cdr.detectChanges();
    }



    constructor(
        public layoutService: LayoutService,
        public el: ElementRef,
        private usetiful: UsetifulService,
        private avatarService: AvatarService,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private renderer: Renderer2,
        private pedidosService: PedidosService
    ) { }
    user_name: string = '';
    userPhoto: string | null = 'assets/layout/images/avatar.png';
    isSidebarOpen(): boolean {
        return this.layoutService.state.sidebarActive || this.isMobile();
    }
    readonly PLACEHOLDER = 'assets/layout/images/avatar.png';
    showAvatarSkeleton = false;
    onAvatarLoad() {
        this.showAvatarSkeleton = false;
    }
    onAvatarError(evt: Event) {
        // mostra skeleton e tenta o placeholder
        this.showAvatarSkeleton = true;

        const img = evt.target as HTMLImageElement;
        // evita loop
        if (!img.src.endsWith(this.PLACEHOLDER)) {
            this.userPhoto = this.PLACEHOLDER; // quando carregar, onAvatarLoad() esconde o skeleton
        } else {
            // se até o placeholder falhar, deixa o skeleton mesmo
        }
    }
    modes = [
        { label: '', value: 'light', icon: 'pi pi-sun' },
        { label: '', value: 'dark', icon: 'pi pi-moon' }
    ];
    async ngOnInit(): Promise<void> {
        this.avatarSubscription = this.avatarService.avatar$.subscribe(avatar => {
            this.userPhoto = avatar;
            this.showAvatarSkeleton = false;
        });
        this.updateLogoSrc();
        this.layoutService.configUpdate$.subscribe(() => {
            this.updateLogoSrc();
        });
        window.addEventListener('resize', this.updateLogoSrc.bind(this));


        let user_id = localStorage.getItem('user_id');
        if (user_id !== null) {
            // Passo 1: carrega o script
            this.usetiful.init(environment.usetifulToken);


            let numericUserId = parseInt(user_id, 10);
            this.pedidosService.getCachedUserDetail(numericUserId).subscribe({
                next: (response: any) => {
                    this.user_name = response?.name || '';
                    this.userPhoto = response?.photo || response?.url_image || 'assets/layout/images/avatar.png';
                    this.showAvatarSkeleton = false;
                    // Passo 2: setar tags / identificar usuário (exemplos)
                    const userId = localStorage.getItem('user_id') ?? undefined;
                    const firstName = response?.name;
                    const lastName = localStorage.getItem('last_name') || undefined;

                    let subType: number | string | undefined;
                    try {
                        const raw = userId ? localStorage.getItem(`user_detail_${userId}`) : null;
                        const detail = raw ? JSON.parse(raw) : null;
                        subType = detail?.sub_type ?? detail?.subs_type;
                    } catch { }

                    if (userId) {
                        this.usetiful.identify(userId, {
                            firstName,
                            lastName,
                            tags: subType != null ? { sub_type: subType } : undefined
                        });
                    }

                },
                error: (error: any) => {

                }
            });
        }

        const viewMode = localStorage.getItem('viewMode');
        this.darkMode = (viewMode === 'dark');
        this.selectedMode = this.darkMode ? 'dark' : 'light';

    }
    private avatarSubscription!: Subscription;
    goProfile(): void {
        this.router.navigate(['/profile']);
    }
    selectedMode: 'light' | 'dark' = 'light';
    onModeChange(mode: 'light' | 'dark') {
        this.selectedMode = mode;
        this.darkMode = (mode === 'dark');      // <-- mantém compatível com toggleTheme()
        this.toggleTheme();                     // <-- reaproveita seus métodos atuais
    }
    darkMode: boolean = false;
    toggleTheme(): void {
        // Determina o novo esquema com base no estado do switch const accessToken = localStorage.getItem('access_token');
        const newScheme = this.darkMode ? 'dark' : 'light';
        localStorage.setItem('viewMode', newScheme);
        this.changeColorScheme(newScheme as ColorScheme);
    }

    changeColorScheme(colorScheme: ColorScheme): void {
        const themeLink = document.getElementById('theme-link') as HTMLLinkElement;
        if (themeLink) {
            const themeLinkHref = themeLink.getAttribute('href');
            const currentColorScheme = 'theme-' + this.layoutService.config.colorScheme;
            const newColorScheme = 'theme-' + colorScheme;
            const newHref = themeLinkHref!.replace(currentColorScheme, newColorScheme);
            this.replaceThemeLink(newHref, () => {
                this.layoutService.config.colorScheme = colorScheme;
                this.layoutService.onConfigUpdate();
            });
        } else {
            console.error('Theme link element not found!');
        }
    }

    replaceThemeLink(href: string, onComplete: () => void): void {
        const id = 'theme-link';
        const themeLink = document.getElementById(id) as HTMLLinkElement;
        const cloneLinkElement = themeLink.cloneNode(true) as HTMLLinkElement;

        cloneLinkElement.setAttribute('href', href);
        cloneLinkElement.setAttribute('id', id + '-clone');

        themeLink.parentNode!.insertBefore(cloneLinkElement, themeLink.nextSibling);

        cloneLinkElement.onload = () => {
            themeLink.remove();
            cloneLinkElement.setAttribute('id', id);
            onComplete();
        };
    }

    ngOnDestroy(): void {
        window.removeEventListener('resize', this.updateLogoSrc.bind(this));
    }
    isDark: boolean = false;
    updateLogoSrc(): void {
        const layoutContainer = document.querySelector('.layout-container');
        const btnAdicionar = this.el.nativeElement.querySelector('.btn-adicionar');

        if (layoutContainer) {
            this.isDark = this.layoutService.config.colorScheme === 'dark' || this.layoutService.config.colorScheme === 'dim';
            const isSidebarActive = this.layoutService.state.sidebarActive || this.isMobile();

            if (this.isDark) {
                //this.logoSrc = 'assets/logo_slicksell_for_dark_version.svg';
                this.logoSrc = 'assets/Logo_escuro_sem.png';
            } else {
                this.logoSrc = 'assets/Logo_claro_sem.svg';
            }

            if (!isSidebarActive) {
                this.logoSrc = 'assets/favicon.png';
            }
        }

        if (this.layoutService.state.sidebarActive || this.isMobile()) {
            this.renderer.addClass(btnAdicionar, 'w-full');
        } else {
            this.renderer.removeClass(btnAdicionar, 'w-full');
        }
    }

    onMouseEnter() {
        if (this.isDesktop() && !this.layoutService.state.anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.layoutService.state.sidebarActive = true;
            this.updateLogoSrc();
        }
    }

    onMouseLeave() {
        if (this.isDesktop() && !this.layoutService.state.anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.layoutService.state.sidebarActive = false;
                    this.updateLogoSrc();
                }, 300);
            }
        }
    }

    anchor() {
        this.layoutService.state.anchored = !this.layoutService.state.anchored;
        if (this.layoutService.state.anchored) {
            this.layoutService.state.chatSidebarVisible = false;
            this.layoutService.state.profileSidebarVisible = false;
        }
    }

    goToLives(): void {
        const timestamp = new Date().getTime();// teste
        this.router.navigate(['/slicks'], { queryParams: { openSidebar: 'true', ts: timestamp } });
    }

    // goToMyPlayer() {
    //     const domainStore = localStorage.getItem('domain_store');
    //     if (domainStore) {
    //         const url = `https://${domainStore}`;
    //         window.open(url, '_blank');
    //     } else {
    //         console.error('domain_store not found in localStorage');
    //     }
    // }



    isDesktop() {
        return window.innerWidth > 991;
    }

    isMobile() {
        return window.innerWidth <= 991;
    }
}
